import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import SnackbarCloseButton from "splash_components/SnackbarCloseButton/SnackbarCloseButton";
import { SnackbarProvider } from 'notistack';
import React from 'react';
import CruxVsStokt from "splash_components/CruxVsStokt/CruxVsStokt";

export default function CruxVsStoktRoot() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#004080",
      },
      secondary: {
        main: "#FFFFFF",
      },
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4500}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
    >
      <ThemeProvider theme={theme}>
        <CruxVsStokt />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
